import "./App.scss";
import React, { useEffect, useMemo, useState } from "react";
import { createTheme, CssBaseline, ThemeProvider } from "@mui/material";
import { useSelector } from "react-redux";

import AppRoutes from "./routes/Routes";
import { SnackbarProvider } from "notistack";

function App() {
  const isAuthenticated = useSelector((state) => state.auth.isAuthenticated);
  const userRole = useSelector((state) => state.auth.userRole);
  const primaryColor = useSelector((state) => state.theme.primaryColor);
  const secondaryColor = useSelector((state) => state.theme.secondaryColor);
  const [colorForBody, setColorForBody] = useState({
    primaryColor: "#FFA447",
    secondaryColor: "#D24545",
  });

  // Function to Create Theme Dynamically
  const createDynamicTheme = (primaryColor, secondaryColor) => {
    return createTheme({
      palette: {
        primary: { main: primaryColor },
        secondary: { main: secondaryColor },
      },
    });
  };

  // Create theme dynamically using Redux values
  const theme = useMemo(() => {
    setColorForBody({ primaryColor, secondaryColor });
    return createDynamicTheme(primaryColor, secondaryColor);
  }, [primaryColor, secondaryColor]);

  useEffect(() => {
    document.documentElement.style.setProperty(
      "--primary-color",
      colorForBody.primaryColor
    );
    document.documentElement.style.setProperty(
      "--secondary-color",
      colorForBody.secondaryColor
    );

    // ✅ Set a lighter background color based on primaryColor (Modify as needed)
    document.documentElement.style.setProperty(
      "--highlight-color",
      `${colorForBody.primaryColor}40` // Adds transparency
    );
  }, [colorForBody]);

  // Fix for hot reloading
  process.env.REACT_APP_FAST_REFRESH = false;

  return (
    <SnackbarProvider maxSnack={5}>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <AppRoutes isAuthenticated={isAuthenticated} userRole={userRole} />
      </ThemeProvider>
    </SnackbarProvider>
  );
}

export default App;
